/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TerminalState } from './TerminalState';
import {
    TerminalStateFromJSON,
    TerminalStateFromJSONTyped,
    TerminalStateToJSON,
} from './TerminalState';

/**
 * 
 * @export
 * @interface GetTerminalDto
 */
export interface GetTerminalDto {
    /**
     * 
     * @type {string}
     * @memberof GetTerminalDto
     */
    pspTerminalId: string;
    /**
     * 
     * @type {string}
     * @memberof GetTerminalDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetTerminalDto
     */
    batteryLevel?: string;
    /**
     * 
     * @type {TerminalState}
     * @memberof GetTerminalDto
     */
    latestState: TerminalState;
}

/**
 * Check if a given object implements the GetTerminalDto interface.
 */
export function instanceOfGetTerminalDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "pspTerminalId" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "latestState" in value;

    return isInstance;
}

export function GetTerminalDtoFromJSON(json: any): GetTerminalDto {
    return GetTerminalDtoFromJSONTyped(json, false);
}

export function GetTerminalDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTerminalDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pspTerminalId': json['pspTerminalId'],
        'name': json['name'],
        'batteryLevel': !exists(json, 'batteryLevel') ? undefined : json['batteryLevel'],
        'latestState': TerminalStateFromJSON(json['latestState']),
    };
}

export function GetTerminalDtoToJSON(value?: GetTerminalDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pspTerminalId': value.pspTerminalId,
        'name': value.name,
        'batteryLevel': value.batteryLevel,
        'latestState': TerminalStateToJSON(value.latestState),
    };
}

